import{BeanOperacao} from './BeanOperacao'
import{BeanMes} from './BeanMes'

export class BeanParecer{
  constructor(
    
    public pareIdCdParecer : string,
    public operIdCdOperacao : string,
    public meseIdCdMeses : string,
	  public pareNrAno : string,
	  public pareTxParecer : string,
	  public usuaIdCdUsuario : string,
	  public pareDhRegistro : string,
	  public pareDhInativo : string,
    public operations : BeanOperacao,
    public month : BeanMes,
    
  ){}
}